/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const fr_clear_vision_but_no_starting_point = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mon produit est bon, mais il ne décolle pas`)
};

const en_clear_vision_but_no_starting_point = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You have a clear vision but you don't know where to start to make it real.`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const clear_vision_but_no_starting_point = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.clear_vision_but_no_starting_point(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("clear_vision_but_no_starting_point", locale)
	if (locale === "fr") return fr_clear_vision_but_no_starting_point(inputs)
	return en_clear_vision_but_no_starting_point(inputs)
};